var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat alt 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58579 5.58579C4.21071 5.96086 4 6.46957 4 7V11C4 11.5304 4.21071 12.0391 4.58579 12.4142C4.96086 12.7893 5.46957 13 6 13H8V16L11 13H13C13.5304 13 14.0391 12.7893 14.4142 12.4142C14.7893 12.0391 15 11.5304 15 11V7C15 6.46957 14.7893 5.96086 14.4142 5.58579C14.0391 5.21071 13.5304 5 13 5H6C5.46957 5 4.96086 5.21071 4.58579 5.58579Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11V9H18C18.5304 9 19.0392 9.21071 19.4142 9.58579C19.7893 9.96086 20 10.4696 20 11V15C20 15.5304 19.7893 16.0391 19.4142 16.4142C19.0392 16.7893 18.5304 17 18 17H16V20L13 17H11C10.661 17 10.342 16.916 10.062 16.767L11.828 15H13C14.0609 15 15.0783 14.5786 15.8284 13.8284C16.5786 13.0783 17 12.0609 17 11Z",
    fill: "#B2B2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticon);
export default __webpack_public_path__ + "static/media/chaticon.719e99e181373e29227ccf31fa2a0c3f.svg";
export { ForwardRef as ReactComponent };